export enum BENEFIT_TYPE {
  TIER = 'tier',
  COBRAND = 'cobrand',
  CORPORATE = 'corporate',
  FF = 'f&f',
}

export enum FLOW {
  TRAVEL_HUB = 'TRAVEL_HUB',
  CKI = 'CKI',
}

export enum FLIGHT_TYPE {
  OW = 'OW',
  RT = 'RT',
  MC = 'MC',
}

export enum FLOW_FOOTER {
  PAYMENT = 'PAYMENT',
  PRINT_TAG = 'PRINTTAG',
}

export enum OPTIONS_MENU {
  PRINTING_BOARDING_PASS = 1,
  SELECTION_SEAT,
  SELECTION_BAGS,
  IS_VENEZUELA,
  MANAGE_EXTRAS,
}

export enum OPTION_MODAL_PASSPORT {
  WRITE_MANUAL_DATA,
  READ_SUCCESS,
}
